/* global $ */

let productLabelLocations;

/**
 * This object hosts functions to support the product detail ui scripts of all available templates
 */
const ProductDetailsUIHelpers = {

  /**
   * Initializes the product label locations
   */
  initProductLabelLocations() {
    productLabelLocations = {
      base_price_below: $('.js-product-labels-base-price-below'),
      product_title_above: $('.js-product-labels-title-above'),
      product_title_below: $('.js-product-labels-title-below'),
    };
  },

  /**
   * Adds product labels to the relevant locations
   * @param {Object} config A product label configuration
   */
  updateProductLabels(config) {
    if (!productLabelLocations) {
      this.initProductLabelLocations();
    }

    let relevantLabels;

    // Check if label configs exist and if they contain a sub-config for the product page
    if (typeof config === 'object' && typeof config.product !== 'undefined') {
      relevantLabels = config.product;
    }

    // Loop over locations.
    Object.keys(productLabelLocations).forEach((location) => {
      // Reset the location's content.
      productLabelLocations[location].empty();

      if (typeof relevantLabels === 'undefined') {
        // We have no labels, stop and take care that all elements are hidden
        this.hideProductLabels();
        return;
      }

      // Check that there is a location to put the labels AND
      // that we have labels to be put into that location.
      if (productLabelLocations[location].length !== 0 && typeof relevantLabels[location] !== 'undefined') {
        // Show the container element.
        productLabelLocations[location].removeClass('hidden');
        // Insert labels into location.
        relevantLabels[location].forEach((label) => {
          // Append a new element.
          productLabelLocations[location].append(`<small class="product-meta">${label}</small>`);
        });
      } else {
        // Hide the container element.
        productLabelLocations[location].addClass('hidden');
      }
    });
  },

  /**
   * Hides the product labels
   */
  hideProductLabels() {
    if (productLabelLocations) {
      Object.keys(productLabelLocations).forEach((location) => {
        productLabelLocations[location].empty().addClass('hidden');
      });
    }
  },
};

export default ProductDetailsUIHelpers;




// WEBPACK FOOTER //
// ./Library/1.0/common/product_details/ui-helpers.js